<template>
  <div class="add modal modal--default">
    <div
      class="modal__panel"
      :class="showAddCustomerModal ? 'modal__panel--in' : 'modal__panel--out'"
    >
      <div class="modal__logo-wrapper">
        <div class="modal__logo"></div>
         </div>
      <div class="modal__close" @click="closeModal()"></div>

      <div class="add__new">{{ $t(`addCustomerModal.${"title"}`) }}</div>

      <div class="add__title">{{ $t(`addCustomerModal.${"subTitle"}`) }}</div>

      <div class="customers">
        <div class="customer" v-if="canCreateCustomer" @click="showAddCompanyModal()">
          <div class="customer__icon customer__icon--company"></div>
          <button class="add__button button button--default">
            {{ $t(`addCustomerModal.${"companyButton"}`) }}
          </button>
        </div>
        <div class="customer" v-if="canCreateCustomer" @click="showAddPrivateModal()">
          <div class="customer__icon customer__icon--private"></div>
          <button class="add__button button button--default">
            {{ $t(`addCustomerModal.${"privateButton"}`) }}
          </button>
        </div>
        <div
          class="customer"
          v-if="!isAddingCustomer && canCreateUser"
          @click="showAddUserModal()"
        >
          <div class="customer__icon customer__icon--user"></div>
          <button class="add__button button button--default">
            {{ $t(`addCustomerModal.${"userButton"}`) }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from "vuex";

// Component name definition
defineOptions({
  name: "AddCustomer"
});

const store = useStore();

// Computed properties (Mapping original Vuex Getters)
const showAddCustomerModal = computed(() => store.getters.showAddCustomerModal);
const isAddingCustomer = computed(() => store.getters.isAddingCustomer);
const isSuperAdmin = computed(() => store.getters.isSuperAdmin);
const canCreateCustomer = computed(() => {
  if (isSuperAdmin.value) return true;
  const teamIds = store.getters.authorizedTeamIds("customer_create");
  return teamIds === null || teamIds.length > 0;
});
const canCreateUser = computed(() => {
  if (isSuperAdmin.value) return true;
  const teamIds = store.getters.authorizedTeamIds("user_create");
  return teamIds === null || teamIds.length > 0;
});

// Operational Methods
const closeModal = () => {
  store.commit("setIsAddingCustomer", false);
  store.commit("setIsAddingPotentialCustomer", false);
  store.commit("setShowAddCustomerModal", false);
  store.commit("setIsAddingMember", false);
};

const showAddCompanyModal = () => {
  store.commit("setShowAddCustomerModal", false);
  store.commit("setShowAddCompanyModal", true);
};

const showAddPrivateModal = () => {
  store.commit("setShowAddCustomerModal", false);
  store.commit("setShowAddPrivateModal", true);
};

const showAddUserModal = () => {
  store.commit("setShowAddCustomerModal", false);
  store.commit("setShowAddUserModal", true);
};
</script>

<style scoped lang="scss">
@use "../assets/scss/add-panel-modal";
</style>
